<template>
  <v-fade-transition>
    <v-card
      class="mx-auto item-card pa-2 mt-5"
      elevation="10"
    >
      <div v-if="item.error" class="notification is-warning">
        <v-card-title>{{ item.title }}</v-card-title>
        <v-card-text v-if="item.body" v-html="$marked(item.body)" />
      </div>
      <div v-else>
        <v-chip
          class="mt-n6 ml-2"
          color="#ffc700"
          text-color="black"
          v-show="isArtefact"
        >
          Artefakt!
        </v-chip>
        <v-card-title>{{ item.title }}</v-card-title>
        <v-card-text v-if="item.body" v-html="$marked(item.body)" />
      </div>
    </v-card>
  </v-fade-transition>
</template>

<script>
export default {
  props: ['item', 'isArtefact'],
  name: 'ItemCard',
  data () {
    return {
      bargainID: '',
      hasErrors: false,
      errorMessage: '',
    }
  },
}
</script>
<style lang="scss">
.item-card {
  background-color: #000000AA !important;
}
</style>
